import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betOrderLiveTimeoutDictionary = createSimpleDictionary(
    [
        { id: 5, name: '5 sec' },
        { id: 10, name: '10 sec' },
        { id: 15, name: '15 sec' },
        { id: 30, name: '30 sec' },
        { id: 60, name: '1 min' },
        { id: 120, name: '2 mins' },
        { id: 300, name: '5 mins' },
        { id: 600, name: '10 mins' },
        { id: 900, name: '15 mins' },
        { id: 1200, name: '20 mins' },
        { id: 1800, name: '30 mins' },
        { id: 2700, name: '45 mins' },
        { id: 3600, name: '60 mins' },
        { id: 4500, name: '75 mins' },
    ],
    []
);
